<template>
    <div v-if="contextMenuItemsGroups.length">
    </div>
    <q-list dense style="min-width: 100px" v-if="contextMenuItemsGroups.length" >
        <div v-for="group in contextMenuItemsGroups" :key="group">
            <q-item  
                v-for="item in group.items.filter(h=>!h.hidden)" 
                :key="item.label" 
                @click="executeAction(item)"
                clickable  
                dense 
                v-ripple
                >
                
                <!-- <q-item-section avatar style="min-width: 30px;" > -->
                    
                <!-- </q-item-section>  -->
                <q-item-section side v-if="item.icon" style="min-width: 28px; padding-right: 8px; color: inherit;">
                    <q-icon :name="item.icon" size="xs" :color="item.color || undefined" />
                </q-item-section>
                <q-item-section>{{ item.label }}</q-item-section>
                <q-item-section side v-if="item.subMenu">
                    <q-icon name="keyboard_arrow_right" />
                </q-item-section>
                <q-menu anchor="top end" self="top start">
                    <q-list dense >
                        <q-item 
                        v-for="subItem in item.subMenu.filter(h=>!h.hidden)" 
                        :key="subItem.label" 
                        @click="executeAction(subItem)"
                        clickable 
                        v-ripple
                        >
                            <!-- <q-item-section avatar v-if="subItem.icon">
                                <q-icon :name="subItem.icon" size="sm" />
                            </q-item-section> -->
                            <q-item-section>{{ subItem.label }}</q-item-section>
                        </q-item>
                    </q-list>
                </q-menu>
            </q-item>
            <div style="height: 1.2px; background: rgba(0,0,0,0.12); margin: 0px;"></div>
            <!-- <q-item>aaaaaa</q-item> -->
        </div>
    </q-list>

    <q-dialog v-model="copydialog"  >
        <q-card style="width: 700px; max-width: 80vw; min-height: 300px;">
             <q-card-section class="row items-center">
                <div>Copiar Al Portapapeles</div>
                <q-space></q-space>
                <q-btn flat round dense icon="close" @click="copydialog=false"></q-btn>
            </q-card-section>
            <q-card-section>
                <q-input type="textarea" v-model="copytext" ref="textarea" style="min-height: 200px" />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn-group push>
                    <q-btn flat icon="content_copy" label='Copiar al portapapeles' @click="copy"></q-btn>
                    <!-- <q-btn flat icon="done" label='Cerrar' @click="copydialog = false"></q-btn> -->
                </q-btn-group>
            </q-card-actions>
        </q-card>
    </q-dialog>
    <q-dialog v-model="form_dialog" persistent>
        <q-card style="min-width: 300px; max-width: 90vw;">
            <q-card-section>
                <FormRenderer 
                    v-model:formData="form.formData"
                    :formMeta="form.formMeta"
                />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn icon="close" @click="form_dialog = false"></q-btn>
                <q-btn icon="check" @click="form.action({...form, api}); form_dialog = false"></q-btn>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Auth } from '@/database'
// import FormRenderer from './SettingTables/RowEditors/FormRenderer.vue';
import { defineAsyncComponent } from 'vue';
export default {
    name: 'VuexContextMenu',
    components: {
        // FormRenderer,
        FormRenderer: defineAsyncComponent(() => import('./SettingTables/RowEditors/FormRenderer.vue'))
    },
    props: {
        column: Object,
        row: {
            type: Object,
            default: null,
        },
        type: {
            type: String,
            default: 'column',
        },
        actions: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return {
            copydialog: false,
            copytext: '',
            form: null,
            form_dialog: false,
        }
    },
    created(){
        // console.log(JSON.stringify(this.contextMenuItemsGroups, null, 2))
    },
    mounted(){
        this.api = new Auth();
    },
    beforeUnmount(){
        this.clearContextMenu()
    },
    
    methods: {
        ...mapActions({
            clearContextMenu: 'clearContextMenu',
        }),
        async executeAction(item){
            const action = item.action;
            if (item.form ){
                this.form = item.form;
                this.form_dialog = true;    
                this.clearContextMenu();
                return 
            } else if (action){
                if (typeof action === 'function'){
                    action();
                } else {
                    if (action == 'copy'){
                        this.copydialog = true;
                        this.copytext = item.value;
                    }                    
                }
                this.clearContextMenu();
            }
        },
        copy(){
            this.$refs.textarea.select()
            document.execCommand('copy')
        },
    },
    computed: {
        ...mapGetters({
            contextMenuItemsGroups: 'getContextMenuItems',
        }),
    },
}
</script>

<!-- import { mapActions, mapGetters } from 'vuex'; -->
<!-- ...mapActions('addContextMenuItems'), -->
<!-- Usage from another component -->

<!-- @contextmenu="addContextMenuItems([
    {
        label: 'Copy',
        action: () => {
            navigator.clipboard.writeText(row[col])
        }
    }
])" -->
